export enum ViewMode {
    Days = 'days',
    Months = 'months',
    Years = 'years',
}
